import React from "react"

import InfoPopover from "../../../../shared_components/widgets/InfoPopover"

export default function ToggleSwitch({
  intl,
  idVal,
  value,
  show,
  disabled,
  label,
  labelInfo,
  popoverInfo,
  onToggle,
  toggleStyle = { marginBottom: "5px", marginLeft: "auto" },
}) {
  return (
    <>
      {show && (
        <div className={"form-check form-switch"} style={toggleStyle}>
          <input
            type={"checkbox"}
            id={idVal}
            className={"form-check-input"}
            disabled={disabled}
            onChange={(e) => {
              onToggle && onToggle(e)
            }}
            checked={value}
          />
          {(labelInfo || label) && (
            <label htmlFor={idVal} className={"form-check-label"}>
              {labelInfo ? intl.formatMessage(labelInfo) : label}
            </label>
          )}
          {popoverInfo && (
            <>
              &nbsp;
              <InfoPopover desc={intl.formatMessage(popoverInfo)} />
            </>
          )}
        </div>
      )}
    </>
  )
}
